import { api } from '../../api';
import { trackPageVisitsQuery } from './tracking.toolkit-queries';
import { TrackPageVisitQueryArguments } from './dto/query-arguments/track-page-visit-query.arguments';

export const trackingEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    trackVisit: builder.mutation<void, TrackPageVisitQueryArguments[]>({
      query: trackPageVisitsQuery,
    }),
  }),
});

export const { useTrackVisitMutation } = trackingEndpoints;
